import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { PublicGuard } from 'ngx-auth';

const routes: Routes = [
  { path: '',           redirectTo: 'login', canActivate: [PublicGuard], pathMatch: 'full' },
  { path: 'login',       component : LoginComponent},
  //{ path: '**',           redirectTo: 'login', canActivate: [PublicGuard], pathMatch: 'full' },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SecurityRoutingModule { }
